export type TLoginFooterProps = {
  mode: keyof typeof EMode;
  children?: JSX.Element | null;
  onClick: () => void;
  onLinkClick?: () => void;
  loading?: boolean;
  formId?: string;
  hideSecondaryAction?: boolean;
  disabled?: boolean;
};

export enum EMode {
  SIGNUP = 'Sign up',
  LOGIN = 'Login',
  VERIFICATION = 'Continue',
  SIGN_UP_VERIFICATION = 'Continue',
  RESET_PASSWORD = 'Reset password',
  NEW_PASSWORD = 'Continue',
  PROFILE = 'Continue',
}

export enum ELinkText {
  SIGNUP = 'Sign up',
  LOGIN = 'Login here',
  VERIFICATION = 'Login here',
  PROFILE = 'Login here',
  RESET_PASSWORD = 'Sign up',
}

export enum ELink {
  SIGNUP = '/login',
  VERIFICATION = '/login',
  PROFILE = '/login',
  LOGIN = '/signup',
  RESET_PASSWORD = '/signup',
}

export enum EQuestion {
  SIGNUP = 'Already have an account?',
  LOGIN = "Don't have an account?",
  VERIFICATION = 'Or go back to',
  PROFILE = 'Already have an account?',
  RESET_PASSWORD = "Don't have an account?",
}
